<template>
  <q-select
    v-model="model"
    :options="options"
    :loading="loading"
    multiple
    emit-value
    map-options
    label="Publisher"
    outlined
    dense
  >
    <template #before-options>
      <q-item clickable>
        <q-item-section>
          <q-checkbox v-model="selectAll" color="tertiary" label="Select all" />
        </q-item-section>
      </q-item>
    </template>

    <template v-slot:option="scope">
      <q-item v-bind="scope.itemProps" v-on="scope.itemEvents">
        <q-item-section>
          <q-checkbox v-model="model" color="tertiary" :label="scope.opt.label" :val="scope.opt.value" />
        </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    options: Array,
    value: Array
  },

  data: () => ({
    selectAll: false
  }),

  computed: {
    model: {
      get() {
        return this.value
      },

      set(newVal) {
        this.$emit('input', newVal)
      }
    }
  },

  watch: {
    selectAll: 'selectAllChanged'
  },

  methods: {
    selectAllChanged(val) {
      if (!val) this.model = []
      else this.model = this.options.map(opt => opt.value)
    }
  }
}
</script>

<style lang="stylus" scoped>
.q-select {
  >>> .q-field__native > span {
    overflow hidden
    text-overflow ellipsis
    white-space nowrap
  }
}
</style>
